const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};


export const getDealsCountApi = async (sq) => {
  let url = `deals/count?sq`
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + url
    ,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getDealsApi = async (sq) => {
  let url = `deals?${sq}`
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + url
                             
    ,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getDealByIdApi = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `deals/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};


export const createDealApi = async (body) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `deals`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: body
  });
  return response.data;
};

export const putDealApi = async (id, body) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + `deals/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: body
  });
  return response.data;
};

export const getTasks = async ({ limit, offset, status, personId, assigneeId, search }) => {
  let qs = `?`;

  if (!isNaN(limit)) {
    qs += `limit=${limit}`
  }
  if (!isNaN(offset)) {
    qs += `&offset=${offset}`
  }
  if (status) {
    qs += `&status=${status}`
  }
  if (personId) {
    qs += `&personId=${personId}`
  }
  if (assigneeId) {
    qs += `&assigneeId=${assigneeId}`
  }
  if (search) {
    qs += `&search=${search}`
  }
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `tasks${qs}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response?.data;
};

export const getTasksById = async (id) => {

  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `tasks/${id}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response?.data;
};


export const getTaskCount = async ({ status }) => {
  let qs = `?`;
  if (status) {
    qs += `status=${status}`
  }

  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `tasks/count${qs}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response?.count;
}

export const createTaskAPI = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `tasks`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const updateTaskByIdApi = async (id, data) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + `tasks/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data
  });
  return response.data;
};


export const getActivityApi = async (id, limit, offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `persons/${id}/activity?limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};
export const getActivityCountApi = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
    `persons/${id}/activity/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

